import { defineStore } from 'pinia';

import { ApiEdmCreate, ApiEdmSave } from '@/api/edm.js';

import { ApiSmsCreate, ApiSmsSave } from '@/api/sms.js';

import { ApiFiltrationCreate, ApiFiltrationSave } from '@/api/filtrations.js';

import { ApiReferrerInfo } from '@/api/campaign.js';

export const assetStore = defineStore({
  id: 'asset',
  state: () => {
    return {
      type: '',
      uuid: '',
      data: {},
      emailKeywords: [],
      smsKeywords: [],
      showModal: false
    };
  },
  actions: {
    setType(type) {
      this.type = type;
    },
    setUuid(uuid) {
      this.uuid = uuid;
    },
    setEmailKeywords(emailKeywords) {
      this.emailKeywords = emailKeywords;
    },
    setSmsKeywords(smsKeywords) {
      this.smsKeywords = smsKeywords;
    },
    setData(data) {
      this.data = data;
    },
    toggleModal(bool) {
      this.showModal = bool;
    },
    async getReferrerInfo() {
      const data = await ApiReferrerInfo();
      if (!data.msg) {
        return data;
      }
    },
    async create(type) {
      let data = null;
      if (type === 'edm') {
        const form = {
          name: 'X script editor edm',
          type: 'inline'
        };
        data = await ApiEdmCreate(form);
      }

      if (type === 'sms') {
        const form = {
          subject: 'X script editor sms',
          type: 'inline'
        };
        data = await ApiSmsCreate(form);
      }

      if (type === 'filtration') {
        const form = {
          name: 'X script editor filtration',
          type: 'inline'
        };
        data = await ApiFiltrationCreate(form);
      }

      if (!data.msg) {
        return data.uuid;
      }
    },
    async save({ type, uuid, data }) {
      const form = {
        uuid,
        data
      };

      if (type === 'edm') {
        await ApiEdmSave(form);
      }

      if (type === 'sms') {
        await ApiSmsSave(form);
      }

      if (type === 'filtration') {
        await ApiFiltrationSave(form);
      }
    }
  }
});
